export default __webpack_public_path__ + "static/spot-illo-morph-light-e56c1fc5a75bc2a4606c6368cee04bc3.mp4";